import { render, staticRenderFns } from "./EvaluacionDesempeñoAcademico.vue?vue&type=template&id=7bae1fee"
import script from "./EvaluacionDesempeñoAcademico.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempeñoAcademico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports